import type { QueryClient } from '@tanstack/react-query';
import { applyFunnelChannelSessionCacheUpdate } from 'src/modules/shared/communications/utils/cache/funnel-channel-sessions/update.util';
import type { CommunicationsRealtimeChannelSessionPayload } from '../../types/realtime.types';

/**
 * Applies a validated realtime channel-session payload to owned caches.
 *
 * @param queryClient - React Query client that owns the Communications caches.
 * @param payload - Validated channel-session realtime payload.
 */
export const applyChannelSessionRealtimePayload = (
  queryClient: QueryClient,
  payload: CommunicationsRealtimeChannelSessionPayload
): void => {
  applyFunnelChannelSessionCacheUpdate({
    queryClient,
    action: payload.action,
    resourceId: payload.resourceId,
    funnelConversationId: payload.funnelConversationId,
    channelSession: payload.resource,
  });
};
